import { Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import LabelComponent from "../../../../../components/Label/LabelComponent";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import CheckboxComponent from "../../../../../components/checkbox/CheckboxComponent";
import { render } from "@testing-library/react";
import TextFieldComponent from "../../../../../components/TextField/TextFieldComponent";
import { ItemCategoria } from "../../../../../interface/item/categoria/ItemCategoria";
import { CatalogoDisponibilidadeDTO, CatalogoMidiaDTO, CatalogoRequestDTO, DiaSemana } from "../CatalogoAdminPrincipal";
import { CatalogoComplemento, CatalogoComplementoEspecifico, CatalogoItemComplemento, ItemCatalogo, ItemDestaque } from "../../../public/CatalogoPage";
import { catalogoService } from "../../../../../service/CatalogoService";
import { Empresa } from "../../../../../provider/empresa/EmpresaContext";
import { formatDinheiroToNumber, formatNumberToDinheiro } from "../../../../../utils/dinheiro";

interface ModalItemCatalogoProps {
    open: boolean;
    onClose: () => void;

    tab: number;
    onChangeTab: (tab: number) => void;

    idEmpresa: number | undefined;
    token: string | null;

    itemCatalogo?: CatalogoRequestDTO;

    categoriaSelecionada: ItemCategoria | undefined;

    onSubmit: (categoria: CatalogoRequestDTO) => void;
}

const buttonStyle = {
    width: '119px',
    height: '42px',
    padding: '8px 24px',
    borderRadius: '8px',
    opacity: 1,
    minWidth: 'auto',

    border: '1px solid var(--color-orange-87, #E8DFD5)',

    fontFamily: '"Font 7", sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0%',
    textAlign: 'center',
    textTransform: 'none',

    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
    boxSizing: 'border-box',

    // // Efeito de hover básico para o botão não parecer estático
    // '&:hover': {
    //     backgroundColor: 'rgba(232, 223, 213, 0.08)', // Um leve reflexo no tom da borda
    //     border: '1px solid var(--color-orange-87, #E8DFD5)',
    // }
}

const labelStyle = {
    fontFamily: '"Font 7", sans-serif',
    //fontWeight: 500,
    fontWeight: "bold",
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0%',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle'
}

const inputStyle = {
    //width: '400px',
    height: '42px',
    opacity: 1,

    // Customização da borda e inputs internos do MUI
    '& .MuiOutlinedInput-root': {
        height: '42px',
        padding: '8px 16px', // Alinha com seu padding de design
        borderRadius: '8px',

        // Cor da borda em repouso
        '& fieldset': {
            border: '1px solid var(--color-orange-87, #E8DFD5)',
        },
        // Cor da borda ao passar o mouse (hover)
        '&:hover fieldset': {
            borderColor: '#FF8C42', // Usando aquele laranja padrão de ontem para o hover, ajuste se preferir!
        },
        // Cor da borda quando estiver focado (clicado)
        '&.Mui-focused fieldset': {
            borderColor: '#FF8C42',
            borderWidth: '1.5px', // Destaca o foco de forma suave
        },
    },
    // Ajuste do espaçamento interno do texto digitado para caber nos 42px de altura
    '& .MuiInputBase-input': {
        padding: 0,
        boxSizing: 'border-box',
    }
};

const rowStyle = {
    display: "flex",
    width: "100%",
    gap: 2
};

const itemStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column"
};

const itemCatalogoLimpo = {
    titulo: "",
    descricao: "",
    promocao: false,
    custoAutomatico: false,
    precoVenda: undefined,
    precoVendaStr: "",
    precoCusto: undefined,
    precoCustoStr: "",
    delivery: true,
    mesa: true,
    balcao: true,
    midias: [],
    pdv: "",
    etiqueta: "",
    disponibilidade: [],
    complementos: [],
    complementosEspecificos: []
}

const ModalItemCatalogo = (props: ModalItemCatalogoProps) => {
    const DISPONIBILIDADE_PADRAO = [
        { diaSemana: DiaSemana.SEGUNDA, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.TERCA, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.QUARTA, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.QUINTA, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.SEXTA, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.SABADO, ativo: false, hrInicial: "", hrFinal: "" },
        { diaSemana: DiaSemana.DOMINGO, ativo: false, hrInicial: "", hrFinal: "" }
    ]

    const [itemCatalogo, setItemCatalogo] = useState<CatalogoRequestDTO>(itemCatalogoLimpo);

    /* COMPLEMENTOS */
    const [complementos, setComplementos] = useState<CatalogoItemComplemento[]>([]);
    const getComplementos = async (id: number, token: string) => {
        if (props.categoriaSelecionada) {
            try {
                const data = await catalogoService.getComplementosAdmin(id, props.categoriaSelecionada.id, token);
                setComplementos(data);
            } catch (e) {
                console.error(e);
            }
        }
    }

    //const [complementosSelecionados, setComplementosSelecionados] = useState<CatalogoComplemento[]>([]);

    const handleComplementoChange = (data: CatalogoItemComplemento) => {
        setComplementos(prev =>
            prev.map(complemento =>
                complemento.id === data.id
                    ? {
                        ...complemento,
                        selecionado: !complemento.selecionado
                    }
                    : complemento
            )
        );
    };

    /* COMPLEMENTOS ADICIONAIS */

    const [complementoAdicional, setComplementoAdicional] = useState<CatalogoComplementoEspecifico>({
        nome: "",
        vlrUnitario: 0,
        vlrUnitarioStr: "",
        ativo: false
    })

    const [complementosAdicionais, setComplementosAdicionais] = useState();

    const handleChangeComplementoAdicional = (label: string, value: string) => {
        setComplementoAdicional({
            ...complementoAdicional,
            [label]: value
        })
    }

    const [complementosEspecificosSelecionados, setComplementosEspecificosSelecionados] = useState<CatalogoComplementoEspecifico[]>([]);

    const handleCreateComplementoAdicional = (complemento: CatalogoComplementoEspecifico) => {
        if (complemento.nome == "" || complemento.vlrUnitarioStr == "") return;

        var complementos = complementosEspecificosSelecionados;
        complementos.push({
            ...complemento,
            vlrUnitario: formatDinheiroToNumber(complemento.vlrUnitarioStr ?? ""),
            ativo: true,
            index: complementos.length + 1
        });

        setComplementosEspecificosSelecionados(complementos);

        setComplementoAdicional({
            nome: "",
            vlrUnitario: 0,
            vlrUnitarioStr: "",
            ativo: false,
        })
    }

    const handleComplementoEspecificoChange = (
        complementoEspecifico: CatalogoComplementoEspecifico
    ) => {
        setComplementosEspecificosSelecionados(atual =>
            atual.map(c =>
                c.index === complementoEspecifico.index
                    ? { ...c, ativo: !c.ativo }
                    : c
            )
        );
    };

    /* */

    const handleChangeItemCatalogo = (label: string, value: string | boolean) => {
        if (!itemCatalogo) return;

        setItemCatalogo({
            ...itemCatalogo,
            [label]: value
        })
    }

    const handleChangeMidias = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (!event.target.files) return;

        const novasMidias: CatalogoMidiaDTO[] = Array.from(event.target.files).map(file => ({
            arquivo: file,
            nome: file.name,
            preview: URL.createObjectURL(file),
            principal: false,
            ativo: true
        }));

        setItemCatalogo(prev => ({
            ...prev,
            midias: [
                ...prev.midias,
                ...novasMidias
            ]
        }));
    };

    const handleRemoveMidia = (index: number) => {
        const midia = itemCatalogo.midias[index];

        if (midia.preview) {
            URL.revokeObjectURL(midia.preview);
        }

        setItemCatalogo(prev => ({
            ...prev,
            midias: prev.midias.filter((_, i) => i !== index)
        }));
    };

    const renderInformacoes = () => {
        return <>
            {/* Imagem */}
            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3, width: "100%" }}>
                <input
                    hidden
                    id="input-imagem"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleChangeMidias}
                />

                <LabelComponent htmlFor="input-imagem" sx={labelStyle}>
                    Imagem do Produto
                </LabelComponent>

                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "row", gap: 1.3, overflow: "hidden" }}>
                    <LabelComponent htmlFor="input-imagem" sx={{ display: "flex", flex: 1 }}>
                        <BoxComponent
                            component="div"
                            sx={{
                                width: 250,
                                height: 250,
                                border: "2px dashed #DDD",
                                borderRadius: 2,
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 1
                            }}
                        >
                            {/* <UploadIcon /> */}
                            Arraste ou clique para upload
                        </BoxComponent>
                    </LabelComponent>

                    <BoxComponent component="div"
                        sx={{
                            display: "flex",
                            //flexWrap: "wrap",
                            gap: 1.3,
                            overflowY: "auto"
                        }}>
                        {itemCatalogo.midias.map((midia, index) => (
                            <BoxComponent component="div" key={index} sx={{ display: "flex", width: 250, height: 250 }}>
                                <img
                                    src={midia.preview}
                                />
                                {/* <ButtonComponent id={`img-`}>
                                    A
                                </ButtonComponent> */}
                            </BoxComponent>
                        ))}
                    </BoxComponent>
                </BoxComponent>
            </BoxComponent>

            {/* Nome | Categoria */}
            <BoxComponent component="div" sx={rowStyle}>
                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="titulo" sx={labelStyle}>
                        Nome do Produto *
                    </LabelComponent>
                    <TextFieldComponent
                        id="titulo"
                        placeholder="Ex: Pizza Margheritta"
                        variant="outlined"
                        value={itemCatalogo?.titulo ?? ""}
                        onChange={(e) => handleChangeItemCatalogo("titulo", e.target.value)}
                        fullWidth
                        type="text"
                        sx={{
                            ...inputStyle,
                            // height: "auto",
                            // '& .MuiOutlinedInput-root': {
                            //     height: 'auto',
                            // }
                        }}
                        required
                    />
                </BoxComponent>

                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="categoria" sx={labelStyle}>
                        Categoria *
                    </LabelComponent>
                    <TextFieldComponent
                        id="categoria"
                        placeholder=""
                        variant="outlined"
                        value={props.categoriaSelecionada?.label}
                        onChange={(e) => handleChangeItemCatalogo("categoria", e.target.value)}
                        fullWidth
                        type="text"
                        sx={{
                            ...inputStyle,
                        }}
                        required
                        disabled
                    />
                </BoxComponent>
            </BoxComponent>

            {/* Venda | Custo */}
            <BoxComponent component="div" sx={rowStyle}>
                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="precoVenda" sx={labelStyle}>
                        Preço de Venda *
                    </LabelComponent>
                    <TextFieldComponent
                        id="precoVenda"
                        variant="outlined"
                        value={itemCatalogo.precoVendaStr ?? ""}
                        onChange={(e) => {
                            handleChangeItemCatalogo("precoVendaStr", e.target.value)
                        }}
                        fullWidth
                        type="text"
                        sx={{
                            ...inputStyle,
                        }}
                        maskDinheiro
                        required
                    />
                </BoxComponent>

                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="titulo" sx={labelStyle}>
                        Preço de Custo
                    </LabelComponent>
                    <TextFieldComponent
                        id="precoCusto"
                        variant="outlined"
                        value={itemCatalogo?.precoCustoStr ?? ""}
                        onChange={(e) => handleChangeItemCatalogo("precoCustoStr", e.target.value)}
                        fullWidth
                        type="text"
                        sx={{
                            ...inputStyle,
                        }}
                        maskDinheiro
                    />
                </BoxComponent>
            </BoxComponent>

            {/* Etiqueta | Código */}
            <BoxComponent component="div" sx={rowStyle}>
                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="etiqueta" sx={labelStyle}>
                        Etiqueta *
                    </LabelComponent>
                    <TextFieldComponent
                        id="etiqueta"
                        variant="outlined"
                        value={itemCatalogo.etiqueta ?? ""}
                        onChange={(e) => handleChangeItemCatalogo("etiqueta", e.target.value)}
                        fullWidth
                        type="text"
                        sx={{
                            ...inputStyle,
                        }}
                    />
                </BoxComponent>

                <BoxComponent component="div" sx={itemStyle}>
                    <LabelComponent htmlFor="pdv" sx={labelStyle}>
                        Código PDV *
                    </LabelComponent>
                    <TextFieldComponent
                        id="pdv"
                        variant="outlined"
                        value={itemCatalogo.pdv ?? 0}
                        onChange={(e) => handleChangeItemCatalogo("pdv", e.target.value)}
                        fullWidth
                        type="number"
                        sx={{
                            ...inputStyle,
                        }}
                    />
                </BoxComponent>
            </BoxComponent>

            {/* Checkboxes */}
            <BoxComponent component="div" sx={rowStyle}>
                <BoxComponent component="div" sx={{
                    ...itemStyle,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    height: "50px",
                    background: "#F8F5F0",
                    borderRadius: 2,
                    px: 2
                }}>
                    <LabelComponent htmlFor="promocao" sx={labelStyle}>
                        Ativar Promoção
                    </LabelComponent>
                    <CheckboxComponent
                        id="promocao"
                        checked={itemCatalogo?.promocao ?? false}
                        onChange={(checked) => handleChangeItemCatalogo("promocao", checked)}
                    />
                </BoxComponent>

                <BoxComponent component="div" sx={{
                    ...itemStyle,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    height: "50px",
                    background: "#F8F5F0",
                    borderRadius: 2,
                    px: 2
                }}>
                    <LabelComponent htmlFor="custoAutomatico" sx={labelStyle}>
                        Custo Automático
                    </LabelComponent>
                    <CheckboxComponent
                        id="custoAutomatico"
                        checked={itemCatalogo?.custoAutomatico ?? false}
                        onChange={(checked) => handleChangeItemCatalogo("custoAutomatico", checked)}
                    />
                </BoxComponent>
            </BoxComponent>

            {/* Descrição */}
            <BoxComponent component="div" sx={{ ...rowStyle, width: "100%", flexDirection: "column", gap: 0 }}>
                <LabelComponent htmlFor="descricao" sx={labelStyle}>
                    Descrição *
                </LabelComponent>
                <TextFieldComponent
                    id="descricao"
                    placeholder="Descreva o produto..."
                    variant="outlined"
                    multiline
                    rows={4}
                    value={itemCatalogo?.descricao ?? ""}
                    onChange={(e) => handleChangeItemCatalogo("descricao", e.target.value)}
                    fullWidth
                    sx={{
                        ...inputStyle,
                        height: "auto",
                        // Customização da borda e inputs internos do MUI
                        '& .MuiOutlinedInput-root': {
                            height: "auto",
                            // Cor da borda em repouso
                            '& fieldset': {
                                border: '1px solid var(--color-orange-87, #E8DFD5)',
                            },
                            // Cor da borda ao passar o mouse (hover)
                            '&:hover fieldset': {
                                borderColor: '#FF8C42', // Usando aquele laranja padrão de ontem para o hover, ajuste se preferir!
                            },
                            // Cor da borda quando estiver focado (clicado)
                            '&.Mui-focused fieldset': {
                                borderColor: '#FF8C42',
                                borderWidth: '1.5px', // Destaca o foco de forma suave
                            },
                        },
                    }}
                    required
                />
            </BoxComponent>
        </>
    }

    const renderComplementosCategoria = () => {
        const headerStyle = {
            fontFamily: '"Font 7", sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0%',
            color: '#2C2C2C',
            display: 'inline-flex',
            alignItems: 'center',
            verticalAlign: 'middle'
        }

        const containerComplemento = (
            complemento: CatalogoComplemento | CatalogoComplementoEspecifico,
            index: number,
            checked: boolean,
            onChange: () => void
        ) => {
            return <BoxComponent key={`complemento-${index}`} component="div" sx={{
                backgroundColor: '#F8F5F0',
                padding: '12px',
                gap: '12px',
                borderRadius: '8px',
                opacity: 1,

                border: '1px solid #E8DFD5',

                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                boxSizing: 'border-box'
            }}>
                <BoxComponent component="div">
                    <CheckboxComponent
                        id={`checkbox-complemento-${index}`}
                        checked={checked}
                        onChange={onChange}
                    />
                </BoxComponent>
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            //fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: '#2C2C2C',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            fontWeight: "bold"
                        }}
                    >
                        {complemento.nome}
                    </TypographyComponent>
                    <TypographyComponent variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0%',
                            color: '#999999',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle'
                        }}
                    >
                        + {formatNumberToDinheiro(complemento.vlrUnitario)}
                    </TypographyComponent>
                </BoxComponent>
            </BoxComponent>
        }

        const renderComplementosGerais = () => {
            if (Array.isArray(complementos) && complementos.length < 1) return <>Sem complementos.</>;

            return <>
                {complementos.map((element: CatalogoItemComplemento, index: number) => {
                    return containerComplemento(
                        element,
                        index,
                        element.selecionado,
                        //complementosSelecionados.some(c => c.id === element.id),
                        //complementosSelecionados.includes(element.id ?? 0),
                        () => handleComplementoChange(element)
                    );
                })}
            </>
        }

        const renderComplementosEspecificos = () => {
            if (Array.isArray(complementosEspecificosSelecionados) && complementosEspecificosSelecionados.length < 1) return <>Sem complementos específicos</>

            return complementosEspecificosSelecionados.map((element: CatalogoComplementoEspecifico, index: number) => {
                return containerComplemento(
                    element,
                    index,
                    element.ativo,
                    () => handleComplementoEspecificoChange(element)
                );
            });
        }

        return <>
            <BoxComponent component="div">
                <TypographyComponent variant="h3" sx={headerStyle}>
                    Complementos da Categoria
                </TypographyComponent>
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                    {renderComplementosGerais()}
                </BoxComponent>
            </BoxComponent >

            <Divider />

            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                <TypographyComponent variant="h3" sx={headerStyle}>
                    Complementos Específicos do Produto
                </TypographyComponent>
                <BoxComponent component="div" sx={{
                    display: "flex",
                    flexDirection: "column",
                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 400,
                    padding: "16px",
                    fontSize: '12px',
                    lineHeight: '16px',
                    letterSpacing: '0%',
                    color: '#999999',
                    backgroundColor: "#F8F5F0",
                    border: '1px solid #E8DFD5',
                    gap: 1.3
                }}>
                    <TypographyComponent variant="body2" sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 500,
                        fontSize: '12px',
                        lineHeight: '16px',
                        letterSpacing: '0%',
                        color: '#666666',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}>
                        Adicionar novo complemento exclusivo para este produto (pode adicionar o mesmo complemento com
                        preços diferentes)
                    </TypographyComponent>
                    <BoxComponent component="div" sx={{ display: "flex", gap: 1.2 }}>
                        <TextFieldComponent
                            id="nome-complemento-adicional"
                            placeholder="Nome do complemento"
                            sx={inputStyle}
                            value={complementoAdicional.nome}
                            onChange={(e) => handleChangeComplementoAdicional("nome", e.target.value)}
                        />
                        <TextFieldComponent
                            id="vlr-complemento-adicional"
                            placeholder="Valor do complemento"
                            sx={inputStyle}
                            value={complementoAdicional.vlrUnitarioStr ?? ""}
                            onChange={(e) => handleChangeComplementoAdicional("vlrUnitarioStr", e.target.value)}
                            maskDinheiro
                        />
                        <ButtonComponent
                            id="add-complemento-adicional"
                            type="button"
                            onClick={() => handleCreateComplementoAdicional(complementoAdicional)}
                        >
                            Adicionar
                        </ButtonComponent>
                    </BoxComponent>
                </BoxComponent>
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                    {renderComplementosEspecificos()}
                </BoxComponent>
            </BoxComponent>
        </>
    }

    /* DISPONIBILIDADE */
    const [disponibilidades, setDisponibilidades] = useState<CatalogoDisponibilidadeDTO[]>(DISPONIBILIDADE_PADRAO);

    const handleChangeDisponibilidade = (
        disponibilidade: CatalogoDisponibilidadeDTO,
        label: keyof CatalogoDisponibilidadeDTO,
        value: string | boolean
    ) => {
        setDisponibilidades(atual =>
            atual.map(item =>
                item.diaSemana === disponibilidade.diaSemana
                    ? {
                        ...item,
                        [label]: value
                    }
                    : item
            )
        );
    }

    const renderDisponibilidade = () => {
        const labelStyle = {
            fontFamily: '"Font 7", sans-serif',
            fontWeight: "bold",
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0%',
            color: '#2C2C2C',
            display: 'inline-flex',
            alignItems: 'center',
            verticalAlign: 'middle'
        };

        const labelInputsHoraStyle = {
            ...labelStyle,
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: '16px',
            color: '#666666'
        };

        return <>
            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0%',
                        color: '#999999',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Configure a disponibilidade do produto por dia e horário:
                </TypographyComponent>

                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", borderRadius: "8px", gap: 1.3 }}>
                    {disponibilidades.map((element: CatalogoDisponibilidadeDTO, index: number) => {
                        const diaSemana = element.diaSemana.substring(0, 1).toUpperCase().concat(element.diaSemana.substring(1).toLowerCase());

                        return <BoxComponent component="div"
                            key={`disponibilidade-${index}`}
                            sx={{
                                border: 1,
                                borderColor: "#E7DED4",
                                borderRadius: 2,
                                p: 2,
                                display: "flex",
                                gap: 2
                            }}
                        >
                            <BoxComponent component="div">
                                <CheckboxComponent id={`disponibilidade-ativo-${index}`}
                                    checked={element.ativo}
                                    onChange={(checked) => handleChangeDisponibilidade(element, "ativo", checked)}
                                />
                            </BoxComponent>
                            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                <BoxComponent component="div" sx={{ display: "flex" }}>
                                    <TypographyComponent variant="body2"
                                        sx={{
                                            fontFamily: '"Font 7", sans-serif',
                                            fontWeight: 600,
                                            fontSize: '16px',
                                            lineHeight: '24px',
                                            letterSpacing: '0%',
                                            color: '#2C2C2C',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            verticalAlign: 'middle',
                                            textTransform: "inherit"
                                        }}
                                    >
                                        {diaSemana}
                                    </TypographyComponent>
                                </BoxComponent>
                                <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", gap: 1.3 }}>
                                    <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                        <LabelComponent htmlFor="hrInicial" sx={labelInputsHoraStyle}>Início</LabelComponent>
                                        <TextFieldComponent
                                            id="hrInicial"
                                            type="time"
                                            value={element.hrInicial}
                                            onChange={(e) => handleChangeDisponibilidade(element, "hrInicial", e.target.value)}
                                            sx={inputStyle}
                                        />
                                    </BoxComponent>
                                    <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                        <LabelComponent htmlFor="hrFinal" sx={labelInputsHoraStyle}>Fim</LabelComponent>
                                        <TextFieldComponent
                                            id="hrFinal"
                                            type="time"
                                            value={element.hrFinal}
                                            onChange={(e) => handleChangeDisponibilidade(element, "hrFinal", e.target.value)}
                                            sx={inputStyle}
                                        />
                                    </BoxComponent>
                                </BoxComponent>
                            </BoxComponent>
                        </BoxComponent>
                    })}
                </BoxComponent>

            </BoxComponent>

            <Divider />

            <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
                <TypographyComponent variant="body2"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '16px',
                        lineHeight: '24px',
                        letterSpacing: '0%',
                        color: '#2C2C2C',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    Disponível para:
                </TypographyComponent>
                <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#F8F5F0", borderRadius: "8px", px: 2 }}>
                    <LabelComponent htmlFor="flag-delivery" sx={labelStyle}>Delivery</LabelComponent>
                    <CheckboxComponent id="flag-delivery" checked={itemCatalogo.delivery} onChange={(checked) => handleChangeItemCatalogo("delivery", checked)} />
                </BoxComponent>
                <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#F8F5F0", borderRadius: "8px", px: 2 }}>
                    <LabelComponent htmlFor="flag-mesa" sx={labelStyle}>Mesa</LabelComponent>
                    <CheckboxComponent id="flag-mesa" checked={itemCatalogo.mesa} onChange={(checked) => handleChangeItemCatalogo("mesa", checked)} />
                </BoxComponent>
                <BoxComponent component="div" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: "#F8F5F0", borderRadius: "8px", px: 2 }}>
                    <LabelComponent htmlFor="flag-balcao" sx={labelStyle}>Balcão</LabelComponent>
                    <CheckboxComponent id="flag-balcao" checked={itemCatalogo.balcao} onChange={(checked) => handleChangeItemCatalogo("balcao", checked)} />
                </BoxComponent>
            </BoxComponent>
        </>
    }

    useEffect(() => {
        if (props.idEmpresa && props.token) {
            getComplementos(props.idEmpresa, props.token);
        }
    }, [props.categoriaSelecionada])

    useEffect(() => {
        setItemCatalogo(itemCatalogoLimpo);
    }, []);

    useEffect(() => {
        if (props.itemCatalogo) {
            setItemCatalogo(props.itemCatalogo);
            // DISPONIBILIDADE, com manipulações
            setDisponibilidades(
                DISPONIBILIDADE_PADRAO.map(item => {
                    const encontrado = props.itemCatalogo?.disponibilidade.find(
                        d => d.diaSemana === item.diaSemana
                    );
            
                    return encontrado
                        ? {
                              ...item,
                              ...encontrado
                          }
                        : item;
                })
            );
            //setComplementos();
            setComplementos(props.itemCatalogo.complementos);

            //setComplementosSelecionados(props.itemCatalogo.complementos);
            setComplementosEspecificosSelecionados(props.itemCatalogo.complementosEspecificos);
        } else {
            setItemCatalogo(itemCatalogoLimpo);
            setDisponibilidades(DISPONIBILIDADE_PADRAO);
            //setComplementosSelecionados([]);
            setComplementosEspecificosSelecionados([]);
        }
    }, [props.itemCatalogo]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        props.onSubmit({
            ...itemCatalogo,
            complementos: complementos,
            complementosEspecificos: complementosEspecificosSelecionados,
            disponibilidade: disponibilidades,
        });
    };

    return <Dialog
        open={props.open}
        onClose={props.onClose}
        PaperProps={{
            component: "form",
            onSubmit: handleSubmit,
            sx: {
                width: "630px",
                maxWidth: "calc(100vw - 32px)"
            }
        }}
    >
        <DialogTitle
            sx={{
                fontFamily: '"Font 7", sans-serif',
                fontWeight: 700,
                fontSize: '24px',
                lineHeight: '32px',
                letterSpacing: '0%',
                color: '#2C2C2C',
                display: 'inline-flex',
                alignItems: 'center',
                verticalAlign: 'middle'
            }}
        >
            {props.itemCatalogo && props.itemCatalogo.id ? "Editar" : "Novo"} Produto
        </DialogTitle>

        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2, maxHeight: "70dvh" }}>
            <Tabs
                value={props.tab}
                onChange={(_, newValue) => props.onChangeTab(newValue)}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    "& .MuiTab-root": {
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0%',
                        textAlign: 'center',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        verticalAlign: 'middle',
                        textTransform: "inherit",
                        color: "#9e9e9e",
                    },
                    "& .Mui-selected": {
                        color: "#F57C00 !important",
                    },
                    "& .MuiTabs-indicator": {
                        backgroundColor: "#F57C00",
                        height: 3,
                    },
                    flexShrink: 0,
                    borderBottom: 1,
                    borderColor: "divider"
                }}
            >
                <Tab label="Informações" />
                <Tab label="Complementos" />
                <Tab label="Disponibilidade" />
            </Tabs>

            <BoxComponent
                component="div"
                sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 0
                }}
            >
                {props.tab === 0 && (
                    <BoxComponent component="div"
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: 1.3
                        }}
                    >
                        {renderInformacoes()}
                    </BoxComponent>
                )}

                {props.tab === 1 && (
                    <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                        {renderComplementosCategoria()}
                    </BoxComponent>
                )}

                {props.tab === 2 && (
                    <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column", gap: 1.3 }}>
                        {renderDisponibilidade()}
                    </BoxComponent>
                )}
            </BoxComponent>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
            <ButtonComponent
                id="cancelar-categoria"
                variant="outlined"
                type="button"
                sx={{ ...buttonStyle, color: '#2C2C2C' }}
                onClick={props.onClose}
            >
                Cancelar
            </ButtonComponent>

            <ButtonComponent
                id="salvar-categoria"
                type="submit"
                variant="outlined"
                sx={{ ...buttonStyle, backgroundColor: "#FF8C42", color: '#FFFFFF' }}
            >
                Salvar
            </ButtonComponent>

        </DialogActions>
    </Dialog>
}

export default ModalItemCatalogo;
